import { useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { GraduationCap, LogOut, LayoutDashboard, ShieldCheck, Menu, LogIn } from "lucide-react";

export default function Header() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const isTenantPage = location.pathname.startsWith("/candidati");

  const doLogout = async () => { await logout(); navigate("/"); };

  return (
    <header data-testid="nav-main-header" className="sticky top-0 z-40 h-20 bg-white/95 backdrop-blur-md border-b border-slate-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-full flex items-center justify-between">
        <button
          data-testid="nav-link-home"
          onClick={() => navigate("/")}
          className="flex items-center gap-3 group min-w-0"
        >
          <div className="h-10 w-10 shrink-0 rounded-lg bg-[#003366] text-white flex items-center justify-center">
            <GraduationCap className="h-5 w-5" />
          </div>
          <div className="text-left min-w-0">
            <div className="font-display font-bold text-[#003366] leading-tight">ITS Match</div>
            <div className="text-xs text-slate-500 leading-tight truncate">Selezione ITS Academy</div>
          </div>
        </button>

        {/* Nav desktop */}
        <nav className="hidden sm:flex items-center gap-2">
          {user && user.role === "super_admin" && (
            <Button data-testid="nav-link-superadmin" variant="ghost" size="sm" onClick={() => navigate("/superadmin")}>
              <ShieldCheck className="h-4 w-4 mr-2" /> Piattaforma
            </Button>
          )}
          {user && user.role === "admin" && (
            <Button data-testid="nav-link-admin" variant="ghost" size="sm" onClick={() => navigate("/admin")}>
              <ShieldCheck className="h-4 w-4 mr-2" /> Amministrazione
            </Button>
          )}
          {user && (
            <Button data-testid="nav-link-dashboard" variant="ghost" size="sm" onClick={() => navigate("/dashboard")}>
              <LayoutDashboard className="h-4 w-4 mr-2" /> Area riservata
            </Button>
          )}
          {user ? (
            <Button data-testid="nav-logout-button" variant="outline" size="sm" onClick={doLogout}>
              <LogOut className="h-4 w-4 mr-2" /> Esci
            </Button>
          ) : (
            <Button data-testid="header-cta-auth" size="sm" className="bg-[#003366] hover:bg-[#002244]" onClick={() => navigate("/auth")}>
              {isTenantPage ? "Candidati" : "Accedi"}
            </Button>
          )}
        </nav>

        {/* Nav mobile: menu hamburger */}
        <div className="sm:hidden">
          <DropdownMenu>
            <DropdownMenuTrigger asChild>
              <Button data-testid="nav-mobile-menu-button" variant="outline" size="sm" aria-label="Apri menu di navigazione">
                <Menu className="h-5 w-5" />
              </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent align="end" className="w-56">
              {user && user.role === "super_admin" && (
                <DropdownMenuItem data-testid="nav-mobile-superadmin" onClick={() => navigate("/superadmin")}>
                  <ShieldCheck className="h-4 w-4 mr-2" /> Piattaforma
                </DropdownMenuItem>
              )}
              {user && user.role === "admin" && (
                <DropdownMenuItem data-testid="nav-mobile-admin" onClick={() => navigate("/admin")}>
                  <ShieldCheck className="h-4 w-4 mr-2" /> Amministrazione
                </DropdownMenuItem>
              )}
              {user && (
                <DropdownMenuItem data-testid="nav-mobile-dashboard" onClick={() => navigate("/dashboard")}>
                  <LayoutDashboard className="h-4 w-4 mr-2" /> Area riservata
                </DropdownMenuItem>
              )}
              {user ? (
                <DropdownMenuItem data-testid="nav-mobile-logout" onClick={doLogout}>
                  <LogOut className="h-4 w-4 mr-2" /> Esci
                </DropdownMenuItem>
              ) : (
                <DropdownMenuItem data-testid="nav-mobile-login" onClick={() => navigate("/auth")}>
                  <LogIn className="h-4 w-4 mr-2" /> {isTenantPage ? "Candidati" : "Accedi"}
                </DropdownMenuItem>
              )}
            </DropdownMenuContent>
          </DropdownMenu>
        </div>
      </div>
    </header>
  );
}
